import React from "react";

class ScheduleContainer extends React.Component {
  state = {
    currentIndex: 0,
    nextIndex: 0,
    isAnimating: false,
  };

  scheduledInstances = [];

  collectScheduledInstances = (instance) =>
    this.scheduledInstances.push(instance);

  // firstSlideTl = null;

  render() {
    const { children } = this.props;
    return React.Children.map(children, (child) => {
      return React.cloneElement(child, {
        ref: this.collectScheduledInstances,
        tlCompleteCallback: this.currentTlCompleteCallback,
        tlReverseCompleteCallback: this.nextTlReverseCompleteCallback,
        beginSlidesWheelCallback: this.beginSlidesWheelCallback,
        scheduledInstances: this.scheduledInstances,
        toSlidesManually: this.toSlidesManually,
      });
    });
  }

  componentDidMount() {
    window.addEventListener("wheel", this.handleWheel);
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const aside = document.querySelector('aside');
  //   const nav = document.querySelector('nav');
  //   if (aside) {
  //     const { currentIndex } = this.state;
  //     if (currentIndex !== 1) {
  //       aside.classList.remove('fadeIn');
  //       nav.classList.remove('fadeOut');
  //     }
  //   }
  // }

  // componentDidUpdate(prevProps, prevState) {
  //   const aside = document.querySelector('aside');
  //   const toggle = document.querySelector('.OnePageScrollContainer__toggle');
  //   if (aside) {
  //     const { currentIndex } = this.state;
  //     if (currentIndex !== 1) {
  //       aside.style.display = 'none';
  //       toggle.style.display = 'none';
  //     } else {
  //       aside.style.display = 'block';
  //       toggle.style.display = 'block';
  //     }
  //   }
  // }

  componentWillUnmount() {
    window.removeEventListener("wheel", this.handleWheel);
    this.scheduledInstances.forEach((instance) => {
      instance.tl && instance.tl.kill();
    });
  }

  // attention
  handleWheel = (e) => {
    if (Math.abs(e.deltaY) < 3) {
      return;
    }
    if (e.deltaY === 0) {
      return;
    }
    const { isAnimating, currentIndex } = this.state;

    if (isAnimating) {
      // if (this.firstSlideTl && this.firstSlideTl.progress() > 0) {
      //   this.firstSlideTl.progress(1);
      // }
    } else {
      const lastIndex = this.scheduledInstances.length - 1;
      const nextIndex = currentIndex + Math.sign(e.deltaY);
      if (
        (currentIndex === 0 && nextIndex < currentIndex) ||
        (currentIndex === lastIndex && nextIndex > currentIndex)
      ) {
        return;
      }
      if (
        currentIndex === lastIndex &&
        nextIndex < currentIndex &&
        this.scheduledInstances[lastIndex].sectionRef.scrollTop !== 0
      ) {
        return;
      }

      const currentTl = this.scheduledInstances[currentIndex].tl;
      if (currentTl) {
        this.setState({
          nextIndex,
          isAnimating: true,
        });
        currentTl.restart();
      }
    }
  };

  toSlidesManually = () => {
    const { isAnimating } = this.state;
    if (!isAnimating) {
      this.setState({
        nextIndex: 1,
        isAnimating: true,
      });
      const currentTl = this.scheduledInstances[0].tl;
      currentTl.restart();
    }
  };

  currentTlCompleteCallback = () => {
    const { currentIndex, nextIndex } = this.state;
    if (nextIndex === 1 && currentIndex === 0) {
      // 第一页下滑后第二页第一个上浮
      if (this.scheduledInstances[1].slideInstances) {
        this.scheduledInstances[1].setState({ isAnimating: true });
        const nextTl =
          this.scheduledInstances[1].slideInstances[0].bottomToMidTl;
        const slides =
          document.querySelector(".Main__section.Slides") ||
          document.querySelector(".Main__section.function-slides");
        slides.style.visibility = "visible";

        const aside = document.querySelector("aside");
        const toggle = document.querySelector(
          ".OnePageScrollContainer__toggle"
        );
        if (aside && toggle) {
          aside.style.display = "block";
          toggle.style.display = "block";
        }

        // this.firstSlideTl = nextTl;
        nextTl.restart();
        return;
      }
    }
    if (nextIndex === 1 && currentIndex === 2) {
      // 第三页上滑后第二页最后一个下沉
      // const nextTl = this.scheduledInstances[1].slideInstances[5].topToMidTl;
      const { slideInstances } = this.scheduledInstances[1];
      const nextTl = slideInstances[slideInstances.length - 1].topToMidTl;
      const slides =
        document.querySelector(".Main__section.Slides") ||
        document.querySelector(".Main__section.function-slides");
      slides.style.visibility = "visible";
      const aside = document.querySelector("aside");
      const toggle = document.querySelector(".OnePageScrollContainer__toggle");
      if (aside && toggle) {
        aside.style.display = "block";
        toggle.style.display = "block";
      }

      nextTl.restart();
      return;
    }
    const nextTl = this.scheduledInstances[nextIndex].tl;
    nextTl.reverse();
  };

  beginSlidesWheelCallback = () => {
    this.setState((state) => {
      const { nextIndex } = state;
      if (state.nextIndex === 1) {
        window.removeEventListener("wheel", this.handleWheel);
      }

      return {
        isAnimating: false,
        currentIndex: nextIndex,
      };
    });
  };

  nextTlReverseCompleteCallback = () => {
    const { currentIndex, nextIndex } = this.state;
    if (currentIndex === 1 && this.scheduledInstances[1].state) {
      if (this.scheduledInstances[1].state.currentIndex === 0) {
        this.setState(
          {
            currentIndex: 0,
          },
          () => {
            window.addEventListener("wheel", this.handleWheel);
          }
        );
      } else {
        this.setState(
          {
            currentIndex: 2,
          },
          () => {
            window.addEventListener("wheel", this.handleWheel);
          }
        );
      }
    } else {
      this.setState({
        currentIndex: nextIndex,
        isAnimating: false,
      });
    }
  };
}

export default ScheduleContainer;
